import { render, staticRenderFns } from "./BrigadaDiagrama.vue?vue&type=template&id=540f8c0c&scoped=true&"
import script from "./BrigadaDiagrama.vue?vue&type=script&lang=js&"
export * from "./BrigadaDiagrama.vue?vue&type=script&lang=js&"
import style0 from "./BrigadaDiagrama.vue?vue&type=style&index=0&id=540f8c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f8c0c",
  null
  
)

export default component.exports